import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import Admin from '../admin';

const Ajouter_acces = ({ show, handleClose, onAccesChange, liste_groupe }) => {
    const [parcours, setParcours] = useState([]);
    const [acces, setAcces] = useState({
        Utilisateurs: false,
        Administration: false,
        Produits: false,
        Groupes: false,
        eligibilite: false,
        AdminEligibilite: false,
        Formation: false,
        Simulation: false,
        QCM: false,
        ExamenBlanc: false,
        AdminExamenBlanc: false,
        Maintenance: false,
        ListeDeDiffusion: false,
        Notification: false,
        Parcours: false,
        Parcoursuser: false,
    });

    // Initialiser les accès en fonction de liste_groupe
    useEffect(() => {
        if (liste_groupe && typeof liste_groupe === 'object' && liste_groupe.acces && Array.isArray(liste_groupe.acces) && liste_groupe.acces.length > 0) {
            // Supposons que nous voulons vérifier les droits d'accès du premier objet dans le tableau acces
            const accesString = liste_groupe.acces[0].acces; // Accéder à la chaîne 'acces'
            // Convertir la représentation sous forme de chaîne du tableau en un tableau réel
            const accesArray = JSON.parse(accesString.replace(/'/g, '"')); // Remplacer les apostrophes par des guillemets pour le parsing JSON

            const newAcces = {
                Utilisateurs: accesArray.includes('Utilisateurs'),
                Administration: accesArray.includes('Administration'),
                Produits: accesArray.includes('Produits'),
                Groupes: accesArray.includes('Groupes'),
                eligibilite: accesArray.includes('eligibilite'),
                AdminEligibilite: accesArray.includes('AdminEligibilite'),
                Formation: accesArray.includes('Formation'),
                Simulation: accesArray.includes('Simulation'),
                QCM: accesArray.includes('QCM'),
                ExamenBlanc: accesArray.includes('ExamenBlanc'),
                AdminExamenBlanc: accesArray.includes('AdminExamenBlanc'),
                Maintenance: accesArray.includes('Maintenance'),
                ListeDeDiffusion: accesArray.includes('ListeDeDiffusion'),
                Notification: accesArray.includes('Notification'),
                Parcours: accesArray.includes('Parcours'),
                Parcoursuser: accesArray.includes('Parcoursuser'),
            };

            setAcces(newAcces);
        } else {

            const newAcces = {
                Utilisateurs: false,
                Administration: false,
                Produits: false,
                Groupes: false,
                eligibilite: false,
                AdminEligibilite: false,
                Formation: false,
                Simulation: false,
                QCM: false,
                ExamenBlanc: false,
                AdminExamenBlanc: false,
                Maintenance: false,
                ListeDeDiffusion: false,
                Notification: false,
                Parcours: false,
                Parcoursuser: false,
            };

            setAcces(newAcces);
        }
    }, [liste_groupe]);

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setAcces((prevAcces) => ({
            ...prevAcces,
            [name]: checked,
        }));
    };

    const generateAccesArray = () => {
        return Object.keys(acces).filter(key => acces[key]); // Retourner le tableau des accès
    };

    const handleSave = () => {
        const accesArray = generateAccesArray();
        onAccesChange(accesArray); // Envoyer le tableau au parent
        handleClose(); // Fermer le modal après l'enregistrement
    };

    


    const fetchParcours = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/liste-parcours/');
            if (response.ok) {
                const data = await response.json();
                setParcours(data);
            } else {
                console.error('Erreur lors de la récupération des parcours');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };
    useEffect(() => {
        fetchParcours();
    }, []);

    useEffect(() => {
        if (parcours.length > 0) {
            const parcoursAcces = {};
            parcours.forEach(item => {
                parcoursAcces[item.titre] = false; // Initialiser chaque parcours comme non sélectionné
            });
    
            setAcces((prevAcces) => ({
                ...prevAcces,
                ...parcoursAcces, // Fusionner avec les accès existants
            }));
        }
    }, [parcours]);
    

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title>Définir les accès</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* First Row */}
                <Form className='row'>
                    <div className='col-4'>
                        <h5>Utilisateurs</h5>
                        <Form.Group>
                            <Form.Check
                                type="checkbox"
                                label="Utilisateurs"
                                name="Utilisateurs"
                                checked={acces.Utilisateurs}
                                onChange={handleCheckboxChange}
                            />
                        </Form.Group>
                    </div>
                    <div className='col-4'>
                        <h5>Produits</h5>
                        <Form.Group>
                            <Form.Check
                                type="checkbox"
                                label="Produits"
                                name="Produits"
                                checked={acces.Produits}
                                onChange={handleCheckboxChange}
                            />
                        </Form.Group>
                    </div>
                    <div className='col-4'>
                        <h5>Groupes</h5>
                        <Form.Group>
                            <Form.Check
                                type="checkbox"
                                label="Groupes"
                                name="Groupes"
                                checked={acces.Groupes}
                                onChange={handleCheckboxChange}
                            />
                        </Form.Group>
                    </div>
                </Form>

                {/* Second Row */}
                <Form className='row mt-3'>
                    <div className='col-4'>
                        <h5>Eligibilite</h5>
                        <Form.Group>
                            <Form.Check
                                type="checkbox"
                                label="eligibilite"
                                name="eligibilite"
                                checked={acces.eligibilite}
                                onChange={handleCheckboxChange}
                            />
                            <Form.Check
                                type="checkbox"
                                label="Eligibilite Admin"
                                name="AdminEligibilite"
                                checked={acces.AdminEligibilite}
                                onChange={handleCheckboxChange}
                            />
                        </Form.Group>
                    </div>
                    <div className='col-4'>
                        <h5>Formation</h5>
                        <Form.Group>
                            <Form.Check
                                type="checkbox"
                                label="Formation"
                                name="Formation"
                                checked={acces.Formation}
                                onChange={handleCheckboxChange}
                            />
                        </Form.Group>
                    </div>
                    <div className='col-4'>
                        <h5>Simulation</h5>
                        <Form.Group>
                            <Form.Check
                                type="checkbox"
                                label="Simulation"
                                name="Simulation"
                                checked={acces.Simulation}
                                onChange={handleCheckboxChange}
                            />
                        </Form.Group>
                    </div>
                </Form>

                {/* Troisième Row */}
                <Form className='row mt-3'>
                    <div className='col-4'>
                        <h5>QCM</h5>
                        <Form.Group>
                            <Form.Check
                                type="checkbox"
                                label="QCM"
                                name="QCM"
                                checked={acces.QCM}
                                onChange={handleCheckboxChange}
                            />
                        </Form.Group>
                    </div>
                    <div className='col-4'>
                        <h5>Examen Blanc</h5>
                        <Form.Group>
                            <Form.Check
                                type="checkbox"
                                label="Examen Blanc"
                                name="ExamenBlanc"
                                checked={acces.ExamenBlanc}
                                onChange={handleCheckboxChange}
                            />
                            <Form.Check
                                type="checkbox"
                                label="Examen Blanc Admin"
                                name="AdminExamenBlanc"
                                checked={acces.AdminExamenBlanc}
                                onChange={handleCheckboxChange}
                            />
                        </Form.Group>
                    </div>
                    <div className='col-4'>
                        <h5>Administration</h5>
                        <Form.Group>
                            <Form.Check
                                type="checkbox"
                                label="Administration"
                                name="Administration"
                                checked={acces.Administration}
                                onChange={handleCheckboxChange}
                            />
                        </Form.Group>
                    </div>
                </Form>
                <Form className='row mt-3'>
                    <div className='col-4'>
                        <h5>Maintenance</h5>
                        <Form.Group>
                            <Form.Check
                                type="checkbox"
                                label="Maintenance"
                                name="Maintenance"
                                checked={acces.Maintenance}
                                onChange={handleCheckboxChange}
                            />
                        </Form.Group>
                    </div>
                    <div className='col-4'>
                        <h5>Liste de diffusion</h5>
                        <Form.Group>
                            <Form.Check
                                type="checkbox"
                                label="ListeDeDiffusion"
                                name="ListeDeDiffusion"
                                checked={acces.ListeDeDiffusion}
                                onChange={handleCheckboxChange}
                            />
                        </Form.Group>
                    </div>
                    <div className='col-4'>
                        <h5>Notification</h5>
                        <Form.Group>
                            <Form.Check
                                type="checkbox"
                                label="Notification"
                                name="Notification"
                                checked={acces.Notification}
                                onChange={handleCheckboxChange}
                            />
                        </Form.Group>
                    </div>
                </Form>
                <Form className='row mt-3'>
                    <div className="col-4">
                        <h5>Parcours</h5>
                        {/* <Form>
                            {parcours.map((item) => (
                                <Form.Group key={item.id}>
                                    <Form.Check
                                        type="checkbox"
                                        label={item.titre}
                                        name={item.titre}
                                        checked={acces[item.titre]}
                                        onChange={handleCheckboxChange}
                                    />
                                </Form.Group>
                            ))}
                        </Form> */}
                            <Form.Group>
                                <Form.Check
                                    type="checkbox"
                                    label="Parcours"
                                    name="Parcours"
                                    checked={acces.Parcours}
                                    onChange={handleCheckboxChange}
                                />
                            </Form.Group>
                    </div>

                    <div className="col-4">
                        <h5>Parcoursuser</h5>
                            <Form.Group>
                                <Form.Check
                                    type="checkbox"
                                    label="Parcoursuser"
                                    name="Parcoursuser"
                                    checked={acces.Parcoursuser}
                                    onChange={handleCheckboxChange}
                                />
                            </Form.Group>
                    </div>

                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Fermer
                </Button>
                <Button variant="success" onClick={handleSave}>
                    Enregistrer
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default Ajouter_acces;
